export const issueTemplatesApi = (client) => ({
    // ── Templates (containers) ──────────────────────────────────
    list: () => client.get('/api/v1/issue-templates').then((r) => r.data),
    get: (id) => client.get(`/api/v1/issue-templates/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/issue-templates', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/issue-templates/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/issue-templates/${id}`).then(() => undefined),
    // ── Items (nested under a template) ──────────────────────────
    listItems: (templateId) => client.get(`/api/v1/issue-templates/${templateId}/items`)
        .then((r) => r.data),
    createItem: (templateId, body) => client.post(`/api/v1/issue-templates/${templateId}/items`, body)
        .then((r) => r.data),
    updateItem: (templateId, itemId, body) => client.patch(`/api/v1/issue-templates/${templateId}/items/${itemId}`, body).then((r) => r.data),
    removeItem: (templateId, itemId) => client.delete(`/api/v1/issue-templates/${templateId}/items/${itemId}`).then(() => undefined),
});
export const publicLocationQrApi = (client) => ({
    boot: (orgSlug, siteId, locationId) => {
        const url = locationId
            ? `/api/v1/location-qr/${encodeURIComponent(orgSlug)}/${siteId}/${locationId}`
            : `/api/v1/location-qr/${encodeURIComponent(orgSlug)}/${siteId}`;
        return client.get(url).then((r) => r.data);
    },
    submit: (orgSlug, siteId, body, locationId) => {
        const url = locationId
            ? `/api/v1/location-qr/${encodeURIComponent(orgSlug)}/${siteId}/${locationId}/submit`
            : `/api/v1/location-qr/${encodeURIComponent(orgSlug)}/${siteId}/submit`;
        return client.post(url, body).then((r) => r.data);
    },
    /** Upload a single image attachment BEFORE submit. Client hits this
     *  once per picked file, receives a public URL back, and stashes
     *  each URL for the final `submit()` call. Server caps at 5 MB per
     *  file and restricts to jpeg/png/webp/heic MIME types. */
    uploadImage: (orgSlug, siteId, file, locationId) => {
        const url = locationId
            ? `/api/v1/location-qr/${encodeURIComponent(orgSlug)}/${siteId}/${locationId}/upload-image`
            : `/api/v1/location-qr/${encodeURIComponent(orgSlug)}/${siteId}/upload-image`;
        const form = new FormData();
        form.append('file', file);
        return client.post(url, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((r) => r.data);
    },
});
//# sourceMappingURL=issue-templates.js.map